import {
    ElectronicSubscriptionName,
    FoundationMonthlyDescription,
    FoundationPlanName,
    FoundationPlusMonthlyDescription, FoundationPlusYearlyDescription,
    FoundationYearlyDescription,
    MonthlySubscriptionName,
    ProMonthlyDescription,
    ProPlanName,
    ProPlusMonthlyDescription,
    ProPlusYearlyDescription,
    ProYearlyDescription,
    YearlySubscriptionName
} from "@/app/lib/pricing/const";

export type StoreSubscription = {
    id: string;
    name: string;
    description: string;
};

export type StoreProduct = {
    id: string;
    name: string;
    acoustic: {
        monthly: StoreSubscription;
        yearly: StoreSubscription;
    },
    electronic: {
        monthly: StoreSubscription;
        yearly: StoreSubscription;
    }
};

export type Store = {
    testMode: boolean;
    products: {
        foundation: StoreProduct;
        pro: StoreProduct;
    };
};

export function createProductStore(
    {
        testMode,
        productId,
        //
        proMonthlyPriceId,
        proYearlyPriceId,
        proPlusMonthlyPriceId,
        proPlusYearlyPriceId,
        //
        foundationMonthlyPriceId,
        foundationYearlyPriceId,
        foundationPlusMonthlyPriceId,
        foundationPlusYearlyPriceId,
    }: {
        testMode: boolean;
        //
        productId: string;
        //
        proMonthlyPriceId: string;
        proYearlyPriceId: string;
        proPlusMonthlyPriceId: string;
        proPlusYearlyPriceId: string;
        //
        foundationMonthlyPriceId: string;
        foundationYearlyPriceId: string;
        foundationPlusMonthlyPriceId: string;
        foundationPlusYearlyPriceId: string;
    }): Store {

    const allIds = [
        proMonthlyPriceId,
        proYearlyPriceId,
        proPlusMonthlyPriceId,
        proPlusYearlyPriceId,
        foundationMonthlyPriceId,
        foundationYearlyPriceId,
        foundationPlusMonthlyPriceId,
        foundationPlusYearlyPriceId
    ];
    if (new Set(allIds).size !== allIds.length) {
        throw new Error('Duplicate price ids');
    }

    return {
        testMode,
        products: {
            pro: {
                id: productId,
                name: ProPlanName,
                acoustic: {
                    monthly: {
                        id: proMonthlyPriceId,
                        name: `${MonthlySubscriptionName}`,
                        description: ProMonthlyDescription
                    },
                    yearly: {
                        id: proYearlyPriceId,
                        name: `${YearlySubscriptionName}`,
                        description: ProYearlyDescription
                    }
                },
                electronic: {
                    monthly: {
                        id: proPlusMonthlyPriceId,
                        name: `${MonthlySubscriptionName} (${ElectronicSubscriptionName})`,
                        description: ProPlusMonthlyDescription
                    },
                    yearly: {
                        id: proPlusYearlyPriceId,
                        name: `${YearlySubscriptionName} (${ElectronicSubscriptionName})`,
                        description: ProPlusYearlyDescription
                    }
                }
            },
            foundation: {
                id: productId,
                name: FoundationPlanName,
                acoustic: {
                    monthly: {
                        id: foundationMonthlyPriceId,
                        name: `${MonthlySubscriptionName}`,
                        description: FoundationMonthlyDescription
                    },
                    yearly: {
                        id: foundationYearlyPriceId,
                        name: `${YearlySubscriptionName}`,
                        description: FoundationYearlyDescription
                    }
                },
                electronic: {
                    monthly: {
                        id: foundationPlusMonthlyPriceId,
                        name: `${MonthlySubscriptionName} (${ElectronicSubscriptionName})`,
                        description: FoundationPlusMonthlyDescription
                    },
                    yearly: {
                        id: foundationPlusYearlyPriceId,
                        name: `${YearlySubscriptionName} (${ElectronicSubscriptionName})`,
                        description: FoundationPlusYearlyDescription
                    }
                }
            },
        }
    };
}
